import { Switch } from "@headlessui/react";
import { useState } from "react";

const SwitchBtn = ({
    currentState = false,
    handleChange,
    value,
    isApiLoading = false
}) => {
    const [status, setStatus] = useState(currentState);

    const toggleStatus = () => {
        setStatus(!status); 
        handleChange(value);
    };

    return (
        <div className='flex h-6 items-center'>
            <Switch
                    checked={status}
                    onChange={toggleStatus}
                    className={`${
                        isApiLoading ? 'bg-ezGray hover:cursor-not-allowed' : status ? 'bg-ezGreen' : 'bg-ezRed'
                        } flex w-8 flex-none cursor-pointer rounded-full p-px transition-colors duration-200 ease-in-out`
                    }
                >
                    <span
                        aria-hidden='true'
                        className={`${
                            status
                            ? 'translate-x-3.5'
                            : 'translate-x-0'
                        } h-4 w-4 transform rounded-full bg-white shadow-sm  transition duration-200 ease-in-out`}
                    />
                </Switch>
        </div>
    );
};

export default SwitchBtn;